import { toast } from '@heidi/design-system/toast';
import { type TemplateResponse } from '@heidi/templates/contracts';
import i18next from 'i18next';

/**
 * Checks if a template has been modified after it was last used and shows a toast notification.
 * This is typically called after note generation completes.
 *
 * @param template - The template to check
 * @returns true if toast was shown, false otherwise
 */
export function checkAndNotifyTemplateModification(
  template: TemplateResponse | null | undefined
): boolean {
  if (!template) {
    return false;
  }

  const { last_modified_ia_feedback_loop, last_used } = template;

  if (!last_modified_ia_feedback_loop || !last_used) {
    return false;
  }

  const modifiedDate = new Date(last_modified_ia_feedback_loop);
  const lastUsedDate = new Date(last_used);

  if (modifiedDate > lastUsedDate) {
    toast({
      title: i18next.t('mkUpdatedTemplateAlert.title'),
      description: i18next.t('mkUpdatedTemplateAlert.description'),
    });
    return true;
  }
  return false;
}
